import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { IJobBase } from '../../../types'
import { NoContent } from '../../atoms/NoContent'
import { JobCard } from '../../molecules/JobCard'
import styles from './index.module.scss'

type Props = {
  items: IJobBase[]
}

export const JobCardList: FC<Props> = ({ items = [] }) => {
  const { t } = useTranslation(['jobs'])
  if (items.length === 0) {
    return <NoContent>{t('求人はまだ掲載されていません。')}</NoContent>
  }

  return (
    <>
      {items.map((item) => {
        return (
          <div key={item.slug} className={styles.item}>
            <JobCard job={item} />
          </div>
        )
      })}
    </>
  )
}
